import dayjs from "dayjs";

/**
 * Check if 2 dates point the the same date and time
 *
 * @param date1
 * @param date2
 * @returns
 */
function isSameDateTime(date1: string, date2: string): boolean {
  const transformedDate1 = dayjs(date1).second(0);
  const transformedDate2 = dayjs(date2).second(0);

  return transformedDate1.toString() === transformedDate2.toString();
}

export default isSameDateTime;
